import { Box, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

export const AccountInterestEmpty: React.FC<{ message?: string }> = ({
	message = 'Aún no encontramos intereses para ti.',
}) => (
	<Box
		sx={{
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			padding: { xs: '24px', sm: '48px' },
			border: '1px solid #E0E0E0',
			borderRadius: '8px',
			backgroundColor: '#FFFFFF',
		}}
	>
		<FavoriteBorderIcon
			sx={{
				fontSize: { xs: '40px', sm: '48px' },
				color: 'primary.main',
			}}
		/>
		<Typography
			sx={{
				fontSize: { xs: '18px', sm: '20px' },
				fontWeight: 'bold',
				marginBottom: '12px',
				textAlign: 'center',
				letterSpacing: '0.15px',
			}}
		>
			{'¡Ups! Parece que está vacío'}
		</Typography>
		<Typography
			sx={{
				fontSize: { xs: '14px', sm: '16px' },
				textAlign: 'center',
				letterSpacing: '0.15px',
			}}
		>
			{message}
		</Typography>
	</Box>
);
